import { render, staticRenderFns } from "./EventoView.vue?vue&type=template&id=49b986a0&scoped=true&"
import script from "./EventoView.vue?vue&type=script&lang=js&"
export * from "./EventoView.vue?vue&type=script&lang=js&"
import style0 from "./EventoView.vue?vue&type=style&index=0&id=49b986a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b986a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VDivider,
  VFlex,
  VLayout,
  VSpacer,
  VSubheader,
  VToolbar,
  VToolbarTitle,
})
